import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { LoadAvailableVivaModulesAction } from '../../domains/availableVivaModules/actions.types';

import type { AvailableVivaModules } from './types';

const initialState: AvailableVivaModules = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<AvailableVivaModules, LoadAvailableVivaModulesAction> = (
  state = initialState,
  action: LoadAvailableVivaModulesAction
) => {
  switch (action.type) {
    case 'AVAILABLE_VIVA_MODULES.LOAD_PENDING':
      return setPending();
    case 'AVAILABLE_VIVA_MODULES.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.availableVivaModules);
    case 'AVAILABLE_VIVA_MODULES.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
